import { BASE_URL } from "./variables";

const FALLBACK_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjU5NSwiYnVzaW5lc3NJZCI6NzEsIk1lbWJlcklEIjo5MTksInVzZXJuYW1lIjoiYW5rb3RhLmFkbWluIiwiZmlyc3ROYW1lIjoiSm9obiIsImxhc3ROYW1lIjoiRG9lIiwiYXBpQWNjZXNzIjpmYWxzZSwiZXhwIjoyNTM0MDIyMTQ0MDB9.oCgeNmQXN2gsf64gLZ4x70AsUUkY6k9tFZDTf5bGll4';

function getToken() {
  try {
    return localStorage.getItem('businessAuthToken') || localStorage.getItem('authToken') || FALLBACK_TOKEN;
  } catch { return FALLBACK_TOKEN; }
}

export const addSpendingPlanLine = async (planLineData) => {
  try {
    const response = await fetch(`${BASE_URL}/add-spending-plan-line`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${getToken()}`
      },
      body: JSON.stringify(planLineData)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error adding spending plan line:", error);
    throw error;
  }
};

export default addSpendingPlanLine;
